import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import Ticker from "@/components/Ticker";
import WelcomePopup from "@/components/WelcomePopup";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import LiveBookingToast from "@/components/LiveBookingToast";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import Analytics from "@/components/Analytics";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Booking from "@/pages/Booking";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Book from "@/pages/Book";
import Courses from "@/pages/Courses";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import FreeKundli from "@/pages/FreeKundli";
import DailyHoroscope from "@/pages/DailyHoroscope";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { useEffect } from "react";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
};

const Layout = ({ children, hideChrome }) => (
    <>
        {!hideChrome && <Navbar />}
        {!hideChrome && <Ticker />}
        <main className="relative z-10">{children}</main>
        {!hideChrome && <Footer />}
        {!hideChrome && <FloatingButtons />}
        {!hideChrome && <StickyMobileCTA />}
        {!hideChrome && <LiveBookingToast />}
        {!hideChrome && <WelcomePopup />}
        {!hideChrome && <ExitIntentPopup />}
    </>
);

function App() {
    return (
        <HelmetProvider>
            <div className="App relative">
                <div className="grain-overlay" />
                <BrowserRouter>
                    <ThemeProvider>
                        <LanguageProvider>
                            <AuthProvider>
                                <ScrollToTop />
                                <Analytics />
                                <Routes>
                                    <Route path="/" element={<Layout><Home /></Layout>} />
                                    <Route path="/about" element={<Layout><About /></Layout>} />
                                    <Route path="/services" element={<Layout><Services /></Layout>} />
                                    <Route path="/booking" element={<Layout><Booking /></Layout>} />
                                    <Route path="/blog" element={<Layout><Blog /></Layout>} />
                                    <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
                                    <Route path="/book" element={<Layout><Book /></Layout>} />
                                    <Route path="/courses" element={<Layout><Courses /></Layout>} />
                                    <Route path="/faq" element={<Layout><FAQ /></Layout>} />
                                    <Route path="/contact" element={<Layout><Contact /></Layout>} />
                                    <Route path="/free-kundli" element={<Layout><FreeKundli /></Layout>} />
                                    <Route path="/daily-horoscope" element={<Layout><DailyHoroscope /></Layout>} />
                                    <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
                                    <Route path="/payment/cancel" element={<Layout><PaymentCancel /></Layout>} />
                                    <Route path="/admin/login" element={<Layout hideChrome><AdminLogin /></Layout>} />
                                    <Route path="/admin" element={<Layout hideChrome><AdminDashboard /></Layout>} />
                                </Routes>
                            </AuthProvider>
                        </LanguageProvider>
                    </ThemeProvider>
                </BrowserRouter>
                <Toaster
                    position="top-center"
                    toastOptions={{
                        style: {
                            background: "#1B2A4A",
                            border: "1px solid rgba(197,162,77,0.35)",
                            color: "#F5F0EB",
                        },
                    }}
                />
            </div>
        </HelmetProvider>
    );
}

export default App;
